export default __webpack_public_path__ + "static/media/israel.4e6276c2.jpg";